const notificationsData = [
  {
    id: 1,
    title: "New Message",
    type: "new-message",
    text: "You have received a new message in your inbox",
    time: "2024-05-16T10:50:00", // Example time in ISO format
  },
  {
    id: 11,
    title: "New Message",
    type: "new-message",
    text: "You have received a new message in your inbox",
    time: "2024-05-16T10:50:00", // Example time in ISO format
  },
  {
    id: 2,
    title: "Reminder",
    type: "reminder",
    text: "Don't forget to submit your report",
    time: "2024-05-15T10:20:00", // Example time in ISO format
  },
  {
    id: 3,
    title: "Alert",
    type: "alert",
    text: "Critical system error detected",
    time: "2024-05-02T10:20:00", // Example time in ISO format
  },
  {
    id: 4,
    title: "Alert",
    type: "alert",
    text: "Critical system error detected",
    time: "2024-01-16T10:20:00", // Example time in ISO format
  },
  {
    id: 5,
    title: "Alert",
    type: "alert",
    text: "Critical system error detected",
    time: "2024-01-12T10:20:00", // Example time in ISO format
  },
];

export default notificationsData;
